import { apiConstants } from "@data/constants/apiConstants"
import { authConstants } from "@data/constants/authConstants"
import { authService } from "@data/services/authService"
import { liveModeConstants } from "@data/constants/liveModeConstants"
import moment from "moment"

const initialState = {
    history: {}, // { "sessionId_YYYY-MM-DD-HH:mm": true, ... }
}

/**
 * Reducer for tracking tutor presence history
 * Used to determine if a tutor has EVER connected to a live session
 * Persisted across app restarts and page refreshes
 */
export function tutorPresence(state = initialState, action) {
    switch (action.type) {
        case authConstants.LOGOUT_401:
        case authConstants.RESET_AUTH_STATE:
        case authService.logout.name + apiConstants._SUCCESS:
        case authService.revokeSanctumToken.name + apiConstants._SUCCESS:
        case authService.deleteAccount.name + apiConstants._SUCCESS:
            return initialState

        case liveModeConstants.SET_TUTOR_EVER_PRESENT:
            return {
                ...state,
                history: {
                    ...state.history,
                    [action.sessionKey]: true,
                },
            }

        case liveModeConstants.CLEAN_OLD_TUTOR_PRESENCE: {
            const now = moment()
            const cutoff = now.clone().subtract(24, "hours")

            // Filter out entries older than 24 hours
            const cleanedHistory = Object.keys(state.history).reduce(
                (acc, key) => {
                    // Extract date from key: "sessionId_YYYY-MM-DD-HH:mm"
                    const datePart = key.split("_").slice(1).join("_")
                    const sessionDate = moment(datePart, "YYYY-MM-DD-HH:mm")

                    // Keep only if within 24 hours
                    if (sessionDate.isAfter(cutoff)) {
                        acc[key] = state.history[key]
                    }

                    return acc
                },
                {}
            )

            return {
                ...state,
                history: cleanedHistory,
            }
        }

        default:
            return state
    }
}
